(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9245,682],{

/***/ 9245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Spliter; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/HomePage/Spliter/Spliter.module.scss
var Spliter_module = __webpack_require__(1341);
var Spliter_module_default = /*#__PURE__*/__webpack_require__.n(Spliter_module);
;// CONCATENATED MODULE: ./src/assets/images/Mu7.png
/* harmony default export */ var Mu7 = ({"src":"/_next/static/media/Mu7.0f8a5d2a.png","height":140,"width":522,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAG1BMVEUdICApKChMaXEOJibNBwduHBwaGhpZEhXjDhCYmSaQAAAACXRSTlN6mwBIQ4hibHkbdLx8AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVR4nGNgYmBkZGblYGJgYmNgYGBnYQIAAXkALD011dcAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(4215);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/helpers/imageHelpers.js
var imageHelpers = __webpack_require__(38);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/HomePage/Spliter/Spliter.jsx









function Spliter(_ref) {
  var primaryTitle = _ref.primaryTitle,
      primaryText = _ref.primaryText,
      secondaryTitle = _ref.secondaryTitle,
      secondaryText = _ref.secondaryText,
      image = _ref.image,
      primaryHtml = _ref.primaryHtml,
      secondaryHtml = _ref.secondaryHtml;

  var _useRouter = (0,router.useRouter)(),
      locale = _useRouter.locale;

  var normalizeValue = function normalizeValue(value) {
    return typeof value === "string" ? value.replace(/`/g, "").trim() : "";
  };

  var resolvedImage = normalizeValue(image);
  var imageSrc = resolvedImage ? (0,imageHelpers/* buildApiUrl */.f8)(resolvedImage) : Mu7;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (Spliter_module_default()).wrapper,
    dir: locale === "ar" ? "rtl" : "ltr",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Container["default"], {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Row["default"], {
        className: "justify-content-between align-items-end gap-2 gap-md-3",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Col["default"], {
          xs: 12,
          lg: 5,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (Spliter_module_default()).column,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Spliter_module_default()).titleBox,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: (Spliter_module_default()).title,
                children: primaryTitle
              })
            }), primaryHtml ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Spliter_module_default()).bodyText,
              dangerouslySetInnerHTML: {
                __html: primaryHtml
              }
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (Spliter_module_default()).bodyText,
              children: primaryText
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Spliter_module_default()).logoWrapper,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: imageSrc,
                alt: primaryTitle || "MU7",
                width: 450,
                height: 240,
                priority: true,
                sizes: "100%"
              })
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col["default"], {
          xs: 12,
          lg: 5,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (Spliter_module_default()).column,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Spliter_module_default()).titleBox2,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: (Spliter_module_default()).title,
                children: secondaryTitle
              })
            }), secondaryHtml ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (Spliter_module_default()).bodyText,
              dangerouslySetInnerHTML: {
                __html: secondaryHtml
              }
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (Spliter_module_default()).bodyText,
              children: secondaryText
            })]
          })
        })]
      })
    })
  });
}

/***/ }),

/***/ 1341:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imagePlaceholder":"Spliter_imagePlaceholder__3Vu1x","wrapper":"Spliter_wrapper__e0ATi","column":"Spliter_column__NlsUj","titleBox":"Spliter_titleBox__LvcZC","title":"Spliter_title__vQEAn","bodyText":"Spliter_bodyText__fu5wu","logoWrapper":"Spliter_logoWrapper__1i1FM","titleBox2":"Spliter_titleBox2__XoFg5"};

/***/ }),

/***/ 682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





const Container = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  fluid = false,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  className,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'container');
  const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, fluid ? `${prefix}${suffix}` : prefix)
  });
});
Container.displayName = 'Container';
/* harmony default export */ __webpack_exports__["default"] = (Container);

/***/ })

}]);